import SockJS from "sockjs-client";
import Stomp from "@stomp/stompjs";

export default {
    data() {
        return {
            // 设置 STOMP 客户端
            $_emWebSocketMixin_stompClient: null,
            // 设置 WebSocket 进入端点
            $_emWebSocketMixin_socket_endpoint: "/em-stomp",
            // 设置订阅消息的请求地址前缀
            $_emWebSocketMixin_subscribe_prefix: "/queue/",
            // 设置订阅地址
            $_emWebSocketMixin_subscribe: "",
            // 设置广播服务器端点，访问服务器中哪个接口
            $_emWebSocketMixin_broadcastApi: "/webSocket/broadcast",
            // 设置点对点服务器端点，访问服务器中哪个接口
            $_emWebSocketMixin_sendUserMessageApi: "/webSocket/sendUserMessage",
            // 发送的内容
            $_emWebSocketMixin_sendContent: "",
            // 接收到的消息
            $_emWebSocketMixin_receiveMessage: null

        }
    },
    computed: {
        $_emWebSocketMixin_client:{
            get()
            {
                return this.$data.$_emWebSocketMixin_stompClient
            },
            set(value){
                this.$data.$_emWebSocketMixin_stompClient = value
            }
        },
        $_emWebSocketMixin_socketUrl: {
            get()
            {
                return process.env.VUE_APP_EM_ADMIN_URL + this.$data.$_emWebSocketMixin_socket_endpoint;
            },
            set(value){
                this.$data.$_emWebSocketMixin_socket_endpoint = value;
            }

        },
        $_emWebSocketMixin_broadcastUrl() {
            return process.env.VUE_APP_EM_ADMIN_URL + this.$data.$_emWebSocketMixin_broadcastApi;
        },
        $_emWebSocketMixin_sendUserMessageUrl() {
            return process.env.VUE_APP_EM_ADMIN_URL + this.$data.$_emWebSocketMixin_sendUserMessageApi;
        },
        $_emWebSocketMixin_subscribeDestination() {
            return this.$data.$_emWebSocketMixin_subscribe_prefix + this.$data.$_emWebSocketMixin_subscribe;
        },
        $_emWebSocketMixin_receiveContent() {
            return this.$data.$_emWebSocketMixin_receiveMessage.content
        },
    },
    methods: {
        /**
         * 连接socket
         */
        $_emWebSocketMixin_connect(successCallback) {
            console.info('in connect function')
            // 设置 SOCKET
            let socket = new SockJS(this.$_emWebSocketMixin_socketUrl);
            // 配置 STOMP 客户端
            this.$data.$_emWebSocketMixin_stompClient = Stomp.over(socket);
            // 获取 TOKEN
            let jwt = localStorage['em_sso_token']
            // STOMP 客户端连接
            this.$data.$_emWebSocketMixin_stompClient.connect({jwt: jwt}, (frame) => {
                // alert("连接成功"+successCallback);
                successCallback && successCallback(frame)
            }, () => {
                this.$_emWebSocketMixin_reconnect(successCallback)
            })
        },
        /**
         * 重新连接
         */
        $_emWebSocketMixin_reconnect(successCallback){
            console.info('in reconnect function')
            let connected = false
            const reconInv = setInterval(() => {
                console.info('in interval' + Math.random())
                // 设置 SOCKET
                // this.socket = new SockJS(socketUrl)
                let socket = new SockJS(this.$_emWebSocketMixin_socketUrl);
                // 配置 STOMP 客户端
                // this.stompClient = Stomp.over(this.socket)
                this.$data.$_emWebSocketMixin_stompClient = Stomp.over(socket);
                // 获取 TOKEN
                let jwt = localStorage['em_sso_token']
                // this.stompClient.connect({}, (frame) => {
                this.$data.$_emWebSocketMixin_stompClient.connect({jwt: jwt},(frame) => {
                    console.info('reconnected success')
                    // 连接成功，清除定时器
                    clearInterval(reconInv)
                    connected = true
                    successCallback && successCallback(frame)
                }, () => {
                    console.info('reconnect failed')
                    console.info('connected:' + connected)
                    if (connected) {
                        console.info('connect break .... so continue reconnect')
                        //递归调用。判断connected=true，说明本次调用重连已经连上了，换言之也就是本次的定时器已经清除过了。然后这是又断了。
                        //所以又可以重新执行连接了
                        this.$_emWebSocketMixin_connect(successCallback)
                    }
                })
            }, 120000)
        },
        /**
         * 断开连接
         */
        $_emWebSocketMixin_disconnect() {
            this.$data.$_emWebSocketMixin_stompClient.disconnect(() => {
                // alert("断开连接");
            });
        },
        /**
         * 订阅信息:测试用
         */
        $_emWebSocketMixin_subscribeSocket() {
            // 输出订阅地址
            alert("设置订阅地址为：" + this.$_emWebSocketMixin_subscribeDestination);
            // 订阅用户消息
            this.$data.$_emWebSocketMixin_stompClient.subscribe("/user" + this.$_emWebSocketMixin_subscribeDestination
                , (responseBody) => {
                    this.$data.$_emWebSocketMixin_receiveMessage = JSON.parse(responseBody.body);
                    console.log("receive user message")
                    console.log(this.$data.$_emWebSocketMixin_receiveMessage);
                    alert(this.$_emWebSocketMixin_receiveContent);
                });
            // 订阅广播消息
            this.$data.$_emWebSocketMixin_stompClient.subscribe(this.$_emWebSocketMixin_subscribeDestination
                , (responseBody) => {
                    this.$data.$_emWebSocketMixin_receiveMessage = JSON.parse(responseBody.body);
                    console.log("receive broadcast message")
                    console.log(this.$data.$_emWebSocketMixin_receiveMessage);
                    alert(this.$_emWebSocketMixin_receiveContent);
                });
        },
        /**
         * 发送消息到用户：测试用
         */
        $_emWebSocketMixin_sendUserMessage(sendUser) {
            // 设置待发送的消息内容
            let message = `{"targetUser":"${sendUser}"
            , "destination": "${this.$_emWebSocketMixin_subscribeDestination}"
            , "content": "${this.$data.$_emWebSocketMixin_sendContent}"}`;
            // 发送消息
            this.$data.$_emWebSocketMixin_stompClient.send(this.$data.$_emWebSocketMixin_sendUserMessageApi, {}, message);
        },
        /**
         * 发送广播消息:测试用
         */
        $_emWebSocketMixin_sendBroadcastMessage() {
            // 设置待发送的消息内容
            let message = `{"destination": "${this.$_emWebSocketMixin_subscribeDestination}"
            , "content": "${this.$data.$_emWebSocketMixin_sendContent}"}`;
            // 发送消息
            this.$data.$_emWebSocketMixin_stompClient.send(this.$data.$_emWebSocketMixin_broadcastApi, {}, message);
        }
    }
};